import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const Home = lazy(() => import('../features/landing/pages/Home'));
const BusinessList = lazy(() => import('../features/profile/pages/BusinessList'));
const Contact = lazy(() => import('../features/landing/pages/Contact'));
const BookingSearch = lazy(() => import('../features/booking/pages/BookingSearch'));
const DemoRequest = lazy(() => import('../features/landing/pages/DemoRequest'));
const BookingSuccess = lazy(() => import('../features/booking/pages/BookingSuccess'));
const BookingCreate = lazy(() => import('../features/booking/pages/BookingCreate'));
const BookingDetails = lazy(() => import('../features/booking/pages/BookingDetails'));
const BusinessProfile = lazy(() => import('../features/profile/pages/BusinessProfile'));
const NotFound = lazy(() => import('../features/shared/pages/NotFound'));
const GizlilikPolitikasi = lazy(() => import('../pages/GizlilikPolitikasi'));
const KullanimKosullari = lazy(() => import('../pages/KullanimKosullari'));
const KvkkAydinlatmaMetni = lazy(() => import('../pages/KvkkAydinlatmaMetni'));
const CerezPolitikasi = lazy(() => import('../pages/CerezPolitikasi'));
const IptalIadeKosullari = lazy(() => import('../pages/IptalIadeKosullari'));

export const enRoutes = [
  { path: '/', element: <Home /> },
  { path: '/businesses', element: <BusinessList /> },
  { path: '/pricing', element: <Navigate to="/contact" replace /> },
  { path: '/gizlilik-politikasi', element: <GizlilikPolitikasi /> },
  { path: '/kullanim-kosullari', element: <KullanimKosullari /> },
  { path: '/kvkk-aydinlatma-metni', element: <KvkkAydinlatmaMetni /> },
  { path: '/cerez-politikasi', element: <CerezPolitikasi /> },
  { path: '/iptal-iade-kosullari', element: <IptalIadeKosullari /> },
  { path: '/contact', element: <Contact /> },
  { path: '/booking/search', element: <BookingSearch /> },
  { path: '/demo-request', element: <DemoRequest /> },
  { path: '/success', element: <BookingSuccess /> },
  { path: '/:slug/booking', element: <BookingCreate /> },
  { path: '/event/:code', element: <BookingDetails /> },
  { path: '/:slug', element: <BusinessProfile /> },
  { path: '/404', element: <NotFound /> },
  { path: '*', element: <NotFound /> }
];

export default enRoutes;
